"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nlCountry = void 0;
var _utils = require("../utils");
var _companyNumber = require("../../companyNumber");
// i18next-extract-mark-ns-start Countries

var nlCountry = exports.nlCountry = function nlCountry(t) {
  return {
    id: 'NL',
    name: t('Netherlands'),
    flag: '🇳🇱',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{4}\s?[A-Z]{0,2}$/;
      return regex.test(zipcode);
    },
    zipcodeHasLetters: true,
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 1012 AB or 1017',
    phonePrefix: '31',
    phoneLength: 9,
    pricingVersion: 14,
    timezone: 'Europe/Amsterdam',
    currency: 'EUR',
    companyNumber: {
      label: _companyNumber.labels.NL,
      checker: _companyNumber.checkers.NL,
      placeholder: '74457659'
    }
  };
};